import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { DomainDataService } from '../../../../../services';
import { AdmissionsAreaService } from '../../../admissions-area.service';
import { AdmissionsProspectsService } from '../../admissions-prospects.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'prospects-all-prospects-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './all-prospects.part.html',
})
export class AllProspectsViewPart implements OnInit {

	private readonly domainDataService = inject(DomainDataService);
	private readonly util = inject(UtilityService);
	private readonly pageService = inject(AdmissionsProspectsService);
	private readonly admissionsAreaService = inject(AdmissionsAreaService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.util, this.domainDataService, this.dialogService, this.admissionsAreaService.app, this.admissionsAreaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accProspects = computed(() => (this.admissionsAreaService.admissionsData()?.accProspects ?? []));


	async ngOnInit() {
		await this.admissionsAreaService.loadAdmissionsData();
	}
}